import { themeGet } from '@styled-system/theme-get';
import styled from 'styled-components/macro';
import { devices } from 'utils/styledHelpers';

import { Button, Text } from '@olist/united';

export const FaqButton = styled(Button).attrs({
  color: 'foundation.primaryDefault',
  variation: 'link',
  icon: 'question-circle-outline',
})`
  && svg > path {
    fill: ${themeGet('colors.foundation.primaryDefault')};
  }
`;

export const CustomSubTitle = styled(Text)`
  span {
    background: ${themeGet('colors.foundation.primaryLight')};
  }
`;

export const PlansContainer = styled.div`
  display: grid;
  gap: 24px;
  grid-template-columns: 1fr 1fr 1fr;

  ${devices.medium} {
    grid-template-columns: 1fr 1fr;

    .plan-selector-item:last-child {
      grid-column: span 3;
    }
  }

  ${devices.mobile} {
    grid-template-columns: 1fr;
  }
`;
